import React from 'react';
import imgResolver from '../utils/img-resolver';

class FinishShiftCandidate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            hours: null,
            price: 0

        };
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.hours === null || this.props.disabled !== nextProps.disabled) {
            const hours = nextProps.hours;
            const price = nextProps.candidate.hiring.price * hours;
            this.setState({price, hours});
            this.props.updateCandidatePay(nextProps.candidate.id, price, hours, nextProps.index);
        }
    }

    getProfilePicture(profile_picture, id) {
        if (profile_picture) {
            return <img className="person-avatar" src={profile_picture} alt=""/>;
        } else {
            return <img className="person-avatar" src={require('../styles/images/team_member.png')} alt=""/>
        }
    }

    forceFloat(number) {
        return parseFloat(number) || 0;
    }

    inputChange(pay, candidateId) {
        const hoursString = this.refs.numberInput.getDOMNode().value.replace(",", ".").replace(/[^0-9.]+/g, "").split("."); //Removes all but numbers
        let hours = hoursString[0];

        if (hoursString.length > 1) {
            hours += "." + hoursString[1].substring(0, 2);
        }

        const price = (pay * this.forceFloat(hours)).toFixed(2);
        this.setState({price, hours});
        this.props.updateCandidatePay(candidateId, price, this.forceFloat(hours), this.props.index);
    }

    incrementValue(n, pay, candidateId) {
        const nextHours = this.forceFloat(this.state.hours) + n;
        const hours = nextHours >= 0 ? nextHours : 0;
        const price = (pay * hours).toFixed(2);
        this.setState({price, hours});
        this.props.updateCandidatePay(candidateId, price, this.forceFloat(hours), this.props.index);
    }

    getHours(candidate) {
        let hours = this.props.hours;

        let labelClasses = 'form-control form-control-number';

        if (!this.props.disabled) {
            hours = (
                <label className={labelClasses}>
                    <div onClick={this.incrementValue.bind(this, 0.5, candidate.hiring.price, candidate.id)} className="arrow-up"></div>
                    <input className="person-hours" ref="numberInput" value={this.state.hours} onChange={this.inputChange.bind(this, candidate.hiring.price, candidate.id)} type="text" />
                    <div onClick={this.incrementValue.bind(this, -0.5, candidate.hiring.price, candidate.id)} className="arrow-down"></div>
                </label>
            );
        }
        return hours;
    }

    render () {
        const candidate = this.props.candidate || {hiring: {}};
        let candidateStatus = "OK";
        if (candidate.hiring.no_show) {
            candidateStatus = "No-show"
        } else if (candidate.hiring.status == 'cancelled') {
            candidateStatus = "Cancelled"
        } else if (candidate.hiring.status == 'cancelled by us') {
            candidateStatus = "Cancelled by us"
        }

        return (
            <div className="table-row worker">
                <div className="align-left">
                    <div className="person">
                        {this.getProfilePicture(candidate.user.profile_picture, candidate.id)}
                        <span className="person-name">{ candidate.user.first_name + ' ' + candidate.user.last_name }</span>
                    </div>
                </div>
                <div>{candidateStatus}</div>
                <div>{DJ_CONST.LOCALE_CONF.currency} {candidate.hiring.price}</div>
                <div>
                    {this.getHours(candidate)}
                </div>
                <div>{DJ_CONST.LOCALE_CONF.currency} {parseFloat(this.state.price).toFixed(2)}</div>
            </div>
        );
    }
}

export default FinishShiftCandidate;



/** WEBPACK FOOTER **
 ** ./app/src/components/FinishShiftCandidate.js
 **/